import { render } from "./SubmitForm.vue?vue&type=template&id=09519274&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&lang=js"
export * from "./SubmitForm.vue?vue&type=script&lang=js"

import "./SubmitForm.vue?vue&type=style&index=0&id=09519274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09519274"]])

export default __exports__